import * as queryString from 'query-string';
import { SkeletonEvent } from '../../types.js';
import { getResponse } from './getResponse.js';

const MF_TEST_VERSION_SEPARATOR = '~';
const MF_ASSETS_FALLBACK_PATH = '/microfrontends/mf_assets';
// eslint-disable-next-line no-empty-function,@typescript-eslint/no-empty-function
function NOOP() { }
function stripTrailingSlash(str) {
    return str.endsWith('/') ? str.slice(0, -1) : str;
}
async function getAllMfData({ testOverridesQueryParams, isAssetsFlattened, mfUrl, mfsToPreload, }) {
    const params = queryString.stringify({
        'test_overrides[]': testOverridesQueryParams,
        flatten: isAssetsFlattened || undefined,
        preloaded_mfs: mfsToPreload,
    });
    const queryParamString = params ? `?${params}` : '';
    return getResponse(`${mfUrl}/allMfData${queryParamString}`);
}
function groupBy(arr, predicator) {
    const result = {};
    arr.forEach(item => {
        const key = predicator(item);
        if (!result[key]) {
            result[key] = [];
        }
        result[key].push(item);
    });
    return result;
}
async function getMfAssets({ testOverridesQueryParams, mfUrl, useMfAssetsFallback = false, emitSkeletonEvent = NOOP, }) {
    emitSkeletonEvent(SkeletonEvent.FetchMfAssetsStart);
    const params = queryString.stringify({
        'test_overrides[]': testOverridesQueryParams,
    });
    const queryParamString = params ? `?${params}` : '';
    try {
        const result = await getResponse(`${mfUrl}/mf-assets${queryParamString}`);
        emitSkeletonEvent(SkeletonEvent.FetchMfAssetsSuccess);
        return result;
    }
    catch (error) {
        emitSkeletonEvent(SkeletonEvent.FetchMfAssetsError, { error });
        // try fetching mf-assets from monolith fallback url
        if (!testOverridesQueryParams && useMfAssetsFallback) {
            try {
                const result = await getResponse(MF_ASSETS_FALLBACK_PATH);
                emitSkeletonEvent(SkeletonEvent.FetchMfAssetsFallbackSuccess);
                return result;
            }
            catch (error) {
                emitSkeletonEvent(SkeletonEvent.FetchMfAssetsFallbackError, { error });
            }
        }
        throw new Error('Failed to fetch mf-assets');
    }
}

export { MF_TEST_VERSION_SEPARATOR, NOOP, getAllMfData, getMfAssets, groupBy, stripTrailingSlash };
